import { useEffect } from 'react';
import { useBreakpoint } from '@moda/om';
import { useLocation } from 'react-router-dom';

export const useScrollHashReferenceToView = () => {
  const location = useLocation();
  const isMobile = useBreakpoint({ lt: 'sm' }).matches;
  const SCROLL_TIMEOUT_MS = 100;
  const MOBILE_OFFSET = -60;
  const DESKTOP_OFFSET = -130;

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ block: 'start', inline: 'start' });
          isMobile ? window.scrollBy(0, MOBILE_OFFSET) : window.scrollBy(0, DESKTOP_OFFSET);
        }, SCROLL_TIMEOUT_MS);
      }
    }
  }, [DESKTOP_OFFSET, MOBILE_OFFSET, isMobile, location]);
};
